import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Breadcrumb, Button, Modal, Col, Form, FormGroup, FormControl, Panel } from 'react-bootstrap'
import { browserHistory } from 'react-router'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import sha1 from 'sha1'

import Collapsible from '../collapsible'
import StatesDropdown from '../statesdropdown'

@observer(['users', 'globals'])
export default class Users extends Component {

  constructor(props) {
    super(props)

    // Trigger data load
    this.props.users.loadAllUsers()
    this.props.globals.setCurrentSubPage('users')

    this.state = {
      showNewUserModal: false,
      showEditUserModal: false
    }
  }

  openNewUserModal() {
    this.setState({
      showNewUserModal: true
    })
  }

  closeNewUserModal() {
    this.setState({
      showNewUserModal: false
    })
  }

  openEditUserModal(id) {
    this.props.users.loadUser(id)

    this.setState({
      showEditUserModal: true
    })
  }

  closeEditUserModal() {
    this.setState({
      showEditUserModal: false
    })
  }

  /*
  onRowClick(row) {
    browserHistory.push('/admin/users/' + row.id)
  }
  */

  addUser() {
    const data = {
      organizationId: this.props.globals.loggedInUser.organizationId,
      groupId: 1,
      username: document.getElementById('newUsername').value,
      password: sha1(document.getElementById('newPassword').value),
      firstName: document.getElementById('newFirstName').value,
      lastName: document.getElementById('newLastName').value,
      address: document.getElementById('newAddress').value,
      city: document.getElementById('newCity').value,
      state: document.getElementById('newState').value,
      email: document.getElementById('newEmail').value,
      phone: document.getElementById('newPhone').value,
      zipCode: document.getElementById('newZipCode').value,
      accessLevel: document.getElementById('accessLevel').value,
      status: 1
    }

    this.props.users.addUser(data)

    this.closeNewUserModal()
  }

  updateUser() {
    const data = {
      id: document.getElementById('editUserId').value,
      organizationId: this.props.globals.loggedInUser.organizationId,
      groupId: 1,
      username: document.getElementById('editUsername').value,
      password: sha1(document.getElementById('editPassword').value),
      firstName: document.getElementById('editFirstName').value,
      lastName: document.getElementById('editLastName').value,
      address: document.getElementById('editAddress').value,
      city: document.getElementById('editCity').value,
      state: document.getElementById('editState').value,
      email: document.getElementById('editEmail').value,
      phone: document.getElementById('editPhone').value,
      zipCode: document.getElementById('editZipCode').value,
      accessLevel: document.getElementById('editAccessLevel').value
    }

    this.props.users.updateUser(data)
    this.closeEditUserModal()
  }

  /*
  deleteUser(id) {
    if (confirm('Are you sure you want to delete this User?')) {
      this.props.users.deleteUser(id)
    }
  }
  */

  inactivateUser(id) {
    if (confirm('Are you sure you want to inactivate this user?')) {
      this.props.users.inactivateUser(id)
    }
  }

  formatActions(cell, row) {
    return (
      <div>
        <Button bsSize="small" bsStyle="warning" id={ cell } onClick={ () => { this.openEditUserModal(cell) } }><i className="fa fa-pencil" aria-hidden="true"></i></Button>
        <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.inactivateUser(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
      </div>
    )
  }

  render() {

    const userAccessLevel = localStorage.getItem('userAccessLevel')
    let userAccessDropdown = ''
    let editUserAccessDropdown = ''

    if (userAccessLevel >= 15) {
      userAccessDropdown = (
        <FormControl componentClass="select" id="accessLevel">
          <option value="15">Site Admin</option>
          <option value="10">Organization Admin</option>
          <option value="5">Rep</option>
        </FormControl>
      )

      editUserAccessDropdown = (
        <FormControl componentClass="select" id="editAccessLevel">
          <option value="15">Site Admin</option>
          <option value="10">Organization Admin</option>
          <option value="5">Rep</option>
        </FormControl>
      )
    } else if (userAccessLevel >= 10) {
      userAccessDropdown = (
        <FormControl componentClass="select" id="accessLevel">
          <option value="10">Organization Admin</option>
          <option value="5">Rep</option>
        </FormControl>
      )

      editUserAccessDropdown = (
        <FormControl componentClass="select" id="editAccessLevel">
          <option value="10">Organization Admin</option>
          <option value="5">Rep</option>
        </FormControl>
      )
    }

    const options = {
      onAddRow: this.addUser.bind(this)
      //onRowClick: this.onRowClick.bind(this)
    }

    const usersTable = (
      <div>
        <Button bsStyle="info" onClick={this.openNewUserModal.bind(this)}><i className="fa fa-plus" aria-hidden="true"></i> New</Button>
        <BootstrapTable
            data={ this.props.users.all }
            striped={ true }
            hover={ true }
            pagination={ true }
            options={ options }
            search={ true }
            bordered={ false } >
          <TableHeaderColumn width="75" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
          <TableHeaderColumn width="150" dataField="username" dataSort={ true }>Username</TableHeaderColumn>
          <TableHeaderColumn width="150" dataField="firstName" dataSort={ true }>First Name</TableHeaderColumn>
          <TableHeaderColumn width="150" dataField="lastName" dataSort={ true }>Last Name</TableHeaderColumn>
          <TableHeaderColumn width="200" dataField="email" dataSort={ true }>Email</TableHeaderColumn>
          <TableHeaderColumn width="150" dataField="accessLevel">Access Level</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
        </BootstrapTable>
      </div>
    )

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            <div className="title_left">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item active>Users</Breadcrumb.Item>
            </Breadcrumb>
            </div>
          </div>
          <div className="clearfix"></div>
          <Collapsible title="Users" content={ usersTable } />
        </div>
        <div style={{ clear: 'both' }}></div>
        <Modal show={ this.state.showNewUserModal } onHide={ this.closeNewUserModal.bind(this) } bsSize="medium">
          <Modal.Header closeButton>
            <Modal.Title>New User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="addUserForm">
              <Panel header={ <h3>User Information</h3> }>
                <FormGroup>
                  <Col sm={ 4 }><FormControl type="text" placeholder="Username" id="newUsername"/></Col>
                  <Col sm={ 4 }><FormControl type="password" placeholder="Password" id="newPassword"/></Col>
                  <Col sm={ 4 }>{ userAccessDropdown }</Col>
                </FormGroup>
              </Panel>
              <Panel header={ <h3>User Details</h3> }>
                <FormGroup >
                  <Col sm={ 6 }><FormControl type="text" placeholder="First Name" id="newFirstName"/></Col>
                  <Col sm={ 6 }><FormControl type="text" placeholder="Last Name" id="newLastName"/></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={ 6 }><FormControl type="text" placeholder="Email" id="newEmail"/></Col>
                  <Col sm={ 6 }><FormControl type="text" placeholder="Phone" id="newPhone"/></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={ 12 }><FormControl type="text" placeholder="Address" id="newAddress"/></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={ 4 }><FormControl type="text" placeholder="City" id="newCity"/></Col>
                  <Col sm={ 4 }><StatesDropdown id="newState" /></Col>
                  <Col sm={ 4 }><FormControl type="text" placeholder="Zip Code" id="newZipCode"/></Col>
                </FormGroup>
              </Panel>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ this.closeNewUserModal.bind(this) }><i className="fa fa-times" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ this.addUser.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={ this.state.showEditUserModal } onHide={ this.closeEditUserModal.bind(this) } bsSize="medium">
          <Modal.Header closeButton>
            <Modal.Title>Edit User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="editUserForm">
              <input type="hidden" id="editUserId" />
              <Panel header={ <h3>User Information</h3> }>
                <FormGroup>
                  <Col sm={ 4 }><FormControl placeholder="Username" id="editUsername"/></Col>
                  <Col sm={ 4 }><FormControl placeholder="Password" type="password" id="editPassword"/></Col>
                  <Col sm={ 4 }>{ editUserAccessDropdown }</Col>
                </FormGroup>
              </Panel>
              <Panel header={ <h3>User Details</h3> }>
                <FormGroup >
                  <Col sm={ 6 }><FormControl placeholder="First Name" id="editFirstName"/></Col>
                  <Col sm={ 6 }><FormControl placeholder="Last Name" id="editLastName"/></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={ 6 }><FormControl placeholder="Email" id="editEmail"/></Col>
                  <Col sm={ 6 }><FormControl placeholder="Phone" id="editPhone"/></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={ 12 }><FormControl placeholder="Address" id="editAddress"/></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={ 4 }><FormControl placeholder="City" id="editCity"/></Col>
                  <Col sm={ 4 }><StatesDropdown id="editState" /></Col>
                  <Col sm={ 4 }><FormControl placeholder="Zip Code" id="editZipCode"/></Col>
                </FormGroup>
              </Panel>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ this.closeEditUserModal.bind(this) }><i className="fa fa-times" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ this.updateUser.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/users.js